var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 6.90469L8.29287 6.39737C8.38099 6.24475 8.32221 6.11 8.29287 6.05915C8.26353 6.00831 8.17621 5.89003 7.99996 5.89003C7.82371 5.89003 7.7364 6.00828 7.70706 6.05915C7.67771 6.11 7.61893 6.24472 7.70706 6.39737L7.99996 6.90469Z",
    fill: "#0D1116"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79519 11.1027C4.76585 11.1535 4.70707 11.2882 4.79519 11.4409C4.88329 11.5935 5.02935 11.61 5.08807 11.61C5.14679 11.61 5.29285 11.5935 5.38097 11.4408L5.67388 10.9336H5.08807C4.91185 10.9336 4.82457 11.0518 4.79519 11.1027Z",
    fill: "#0D1116"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29773 9.99607H8.70229L8.00001 8.77969L7.29773 9.99607Z",
    fill: "#0D1116"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.0625C10.2411 4.0625 10.0312 3.85262 10.0312 3.59375V0H3.3125C2.53709 0 1.90625 0.630844 1.90625 1.40625V14.5938C1.90625 15.3692 2.53709 16 3.3125 16H12.6875C13.4629 16 14.0938 15.3692 14.0938 14.5938V4.0625H10.5ZM12.0166 11.9096C11.7861 12.309 11.3731 12.5475 10.9119 12.5475C10.4507 12.5475 10.0377 12.309 9.80706 11.9096L9.24353 10.9336H6.75647L6.19294 11.9096C5.96234 12.309 5.54931 12.5475 5.08813 12.5475H5.08809C4.62691 12.5475 4.21391 12.309 3.98334 11.9096C3.75275 11.5102 3.75272 11.0333 3.98334 10.6339C4.21394 10.2345 4.62694 9.99606 5.08813 9.99606H6.21519L7.45872 7.84219L6.89519 6.86613C6.66459 6.46672 6.66456 5.98981 6.89519 5.59041C7.12578 5.191 7.53878 4.95253 8 4.95253C8.46122 4.95253 8.87422 5.19097 9.10481 5.59041C9.33544 5.98981 9.33541 6.46672 9.10481 6.86613L8.54125 7.84219L9.78478 9.99606H10.9118C11.373 9.99606 11.786 10.2345 12.0166 10.6339C12.2473 11.0333 12.2472 11.5102 12.0166 11.9096Z",
    fill: "#0D1116"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9119 10.9336H10.326L10.619 11.4409C10.7071 11.5935 10.8531 11.61 10.9119 11.61C10.9706 11.61 11.1166 11.5935 11.2047 11.4409C11.2929 11.2882 11.2341 11.1535 11.2047 11.1027C11.1754 11.0518 11.0881 10.9336 10.9119 10.9336Z",
    fill: "#0D1116"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9688 0.274475V3.12501H13.8191L10.9688 0.274475Z",
    fill: "#0D1116"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/Pdf.1171330942cb73ff45bb3e20c3e093f3.svg";
export { ForwardRef as ReactComponent };